"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_select_input_1 = require("@hotelplan/components.common.select-input");
const graphql_types_1 = require("@hotelplan/graphql.types");
const TravelDates_mappers_1 = require("./TravelDates.mappers");
// minDuration-maxDuration-durationType
// Example of testIds: 1-1-night, 1-18-week, 1-1-week
const generateTestIdFromDurationValue = ({ duration, type, }) => {
    return [duration[0], duration[duration.length - 1], type].join('-');
};
const generateDropdownOptions = (durations, t) => {
    const groupedDurations = {
        [graphql_types_1.SearchPeriodType.Exact]: [],
        [graphql_types_1.SearchPeriodType.Flexible]: [],
    };
    durations.forEach(({ value, label }) => {
        const searchPeriod = (0, TravelDates_mappers_1.getDurationSearchPeriod)(value);
        groupedDurations[searchPeriod].push({
            label,
            value: JSON.stringify(value),
            testId: generateTestIdFromDurationValue(value),
        });
    });
    return [
        {
            value: t('search:dates.exact'),
            label: t('search:dates.exact'),
            disabled: true,
        },
        ...groupedDurations[graphql_types_1.SearchPeriodType.Exact],
        {
            value: t('search:dates.flexible'),
            label: t('search:dates.flexible'),
            disabled: true,
        },
        ...groupedDurations[graphql_types_1.SearchPeriodType.Flexible],
    ];
};
const DurationDropdownWrapper = styled_components_1.default.div(({ theme }) => theme.travelDates.durationDropdownWrapper);
const TravelDatesDurationDropdown = ({ currentDuration, onDurationSelect, durations, className, }) => {
    const [t] = (0, next_i18next_1.useTranslation)('search');
    return (react_1.default.createElement(DurationDropdownWrapper, { className: className },
        react_1.default.createElement(components_common_select_input_1.SelectInput, { value: JSON.stringify(currentDuration), onChange: onDurationSelect, label: t('dates.duration.select'), hideLabel: true, options: generateDropdownOptions(durations, t), "data-id": "travelDatesDurationDropdown", name: "travelDatesDurationDropdown", id: "travelDatesDurationDropdown" })));
};
exports.default = TravelDatesDurationDropdown;
//# sourceMappingURL=TravelDatesDurationDropdown.js.map